import axios from "axios";
import store from "@/store";

const http = axios.create({
  baseURL: "https://staging-multpex.staging-voucher-api.multpex.com.br/",
  //https://staging-multpex.staging-voucher-api.multpex.com.br
  headers: {
    Accept: "application/json",
    "Content-Type": "applicattion/json;",
  },
});

const apiv3 = axios.create({
  baseURL: " ",
  headers: {
    Accept: "application/json",
    "Content-Type": "applicattion/json;",
  },
});

apiv3.interceptors.request.use(
  function (config) {
    const token = store.state.autenticacao.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (erro) {
    console.log(erro);
    return Promise.reject(erro);
  }
);

http.interceptors.request.use(
  async function (config) {
    const token = store.state.autenticacao.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (erro) {
    console.log(erro);
    return Promise.reject(erro);
  }
);

export default http;
export { apiv3 };
